 import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  doc,
  getDoc,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { db_fire } from "../firebase";

export const createFreeMealCoupon = async (userId, platform) => {
  // 🔍 check user
  const userRef = doc(db_fire, "users", userId);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) {
    throw new Error("User not found");
  }

  if (userSnap.data().rewardCount < 10) {
    throw new Error("You need 10 rewards to unlock this coupon");
  }
 

  const expiresAt = Timestamp.fromMillis(
    Date.now() + 30 * 24 * 60 * 60 * 1000
  );

  await addDoc(collection(db_fire, "coupons"), {
    couponCode: generateCouponCode(),
    userId,
    platform,
    type: "free_meal",
    status: "active",
    createdAt: serverTimestamp(),
    expiresAt,
  });
};


const generateCouponCode = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let code = "KMS";
  for (let i = 0; i < 6; i++) {
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
}; 